import type React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { ColumnConfig } from "../hooks";

import { HeaderCell, QuestionsHeaderCell } from "./styles";

interface GridHeaderProps {
  columns: ColumnConfig[];
}

export const GridHeader: React.FC<GridHeaderProps> = ({ columns }) => {
  const { t } = useTranslation();

  return (
    <Box display="contents">
      <QuestionsHeaderCell data-testid="questions-header">
        <Typography variant="subtitle2">{t("patients.health_reports.questions")}</Typography>
      </QuestionsHeaderCell>

      {columns.map(column => (
        <HeaderCell key={column.id} data-testid={`column-header-${column.id}`}>
          <Stack spacing={0.5} flexDirection="row" flexWrap="wrap" justifyContent="space-between" flex={1}>
            <Typography variant="subtitle2">{column.header}</Typography>
            <Typography variant="subtitle1">{column.subheader}</Typography>
          </Stack>
        </HeaderCell>
      ))}
    </Box>
  );
};
